import { WORK } from "@/content";

export const Work = () => (
  <section className="work" id="registros" data-testid="work-section">
    <div className="wrap">
      <div className="section-head">
        <p className="eyebrow">{WORK.eyebrow}</p>
        <h2>{WORK.title}</h2>
        <p>{WORK.intro}</p>
      </div>
      <div className="media-grid">
        {WORK.items.map((item) => (
          <figure key={item.title} className={item.landscape ? "landscape" : ""}>
            {item.type === "video" ? (
              <video
                controls
                playsInline
                preload="none"
                poster={item.poster}
                aria-label={item.title}
                data-testid={`work-video-${item.title}`}
              >
                <source src={item.src} type="video/mp4" />
                Seu navegador não suporta vídeo.
              </video>
            ) : (
              <img
                src={item.src}
                alt={item.alt}
                loading="lazy"
                decoding="async"
              />
            )}
            <figcaption>
              <strong>{item.title}</strong>
              {item.caption}
            </figcaption>
          </figure>
        ))}
      </div>
      <a className="next-link" href={WORK.nextLink.href} data-testid="work-next-link">
        {WORK.nextLink.label}
      </a>
    </div>
  </section>
);
